import { useMutation } from "@tanstack/react-query";
import { onboardCustomer } from "../../lib/http/onboardCustomer";

export const useOnboardCustomer = () => {
    return useMutation({mutationFn: onboardCustomer});
};
